import React, { useState, useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import LandingPage from "./components/LandingPage";
const Dashboard = lazy(() => import("./components/Dashboard"));
import TermsAndConditions from "./components/TermsAndConditions";
import FunctionaliteitenPagina from "./components/FunctionaliteitenPagina";
import CookiesPolicy from "./components/CookiesPolicy";
import PrivacyBeleid from "./components/PrivacyBeleid";
const PasswordResetPage = lazy(() => import("./components/PasswordResetPage"));
const PaymentSuccess = lazy(() => import("./components/PaymentSuccess"));
const PaymentCancel = lazy(() => import("./components/PaymentCancel"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));
import FaqPage from "./components/FaqPage";
const VerifyEmailChange = lazy(() => import("./components/VerifyEmailChange"));
const GoogleAdsSelectAccount = lazy(() => import("./components/GoogleAdsSelectAccount"));
import AuthModal from "./components/AuthModal";
import OverOns from "./components/OverOns";
import HoeHetWerkt from "./components/HoeHetWerkt";
import Contact from "./components/Contact";
import Pricing from "./components/Pricing";
import SeoLandingPage from "./components/SeoLandingPage";
const TokenAuthPage = lazy(() => import("./components/TokenAuthPage"));
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios defaults
axios.defaults.baseURL = API;
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-b-2 border-brand" role="status" aria-label="Loading" /></div>}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/over-ons" element={<OverOns />} />
              <Route path="/hoe-het-werkt" element={<HoeHetWerkt />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/verify-email-change" element={<VerifyEmailChange />} />
              <Route path="/google-ads/select" element={<GoogleAdsSelectAccount />} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
              <Route path="/algemene-voorwaarden" element={<TermsAndConditions />} />
              <Route path="/functionaliteiten" element={<FunctionaliteitenPagina />} />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route path="/privacy-beleid" element={<PrivacyBeleid />} />
              <Route path="/reset-password" element={<PasswordResetPage />} />
              <Route path="/verify-email" element={<TokenAuthPage variant="verify" />} />
              <Route path="/magic-login" element={<TokenAuthPage variant="magic" />} />
              <Route path="/:slug" element={<SeoLandingPage />} />
            </Routes>
            </Suspense>
            <Toaster position="bottom-right" richColors />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </I18nextProvider>
  );
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/" replace />;
};

export default App;